import Echo from 'laravel-echo';

const echoHost = process.env.MIX_ECHO_HOST || process.env.MIX_APP_URL || window.location.hostname;

window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: echoHost + ':2053'
    // @see https://github.com/tlaverdure/laravel-echo-server/issues/162#issuecomment-415830727
    // transports: ['websocket', 'polling', 'flashsocket'],
    /*auth: {
        headers: {
            Authorization: 'bearer APP_ID'
        }
    }*/
});
